module.exports = __webpack_public_path__ + "static/button-caseandpunctuation-do-a419fd78b370124e7f2aa23286a90bbc.png";